import { useState } from "react";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { PasswordInput } from "@/components/PasswordInput";
import { useAuth } from "@/context/AuthContext";
import { api, errMsg } from "@/lib/api";

export const PW_RULE = "At least 8 characters, with letters and numbers.";

export const pwError = (pw, confirm) =>
  pw.length < 8 || !/[A-Za-z]/.test(pw) || !/\d/.test(pw) ? PW_RULE : pw !== confirm ? "The two new passwords do not match" : "";

export function ChangePasswordForm({ onDone }) {
  const { user, setUser } = useAuth();
  const [f, setF] = useState({ current: "", next: "", confirm: "" });
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    const bad = pwError(f.next, f.confirm);
    if (bad) return setError(bad);
    setBusy(true);
    setError("");
    try {
      const { data } = await api.post("/auth/change-password", { current_password: f.current, new_password: f.next });
      setUser({ ...user, ...data });
      toast.success("Password changed");
      onDone?.();
    } catch (err) { setError(errMsg(err)); } finally { setBusy(false); }
  };

  return (
    <form onSubmit={submit} className="space-y-4" data-testid="change-password-form">
      <div className="space-y-1"><Label>Current password</Label><PasswordInput required value={f.current} onChange={set("current")} autoComplete="current-password" className="h-11 bg-white" data-testid="cp-current-input" /></div>
      <div className="space-y-1"><Label>New password</Label><PasswordInput required value={f.next} onChange={set("next")} autoComplete="new-password" className="h-11 bg-white" data-testid="cp-new-input" />
        <p className="text-xs text-muted-foreground">{PW_RULE}</p></div>
      <div className="space-y-1"><Label>Confirm new password</Label><PasswordInput required value={f.confirm} onChange={set("confirm")} autoComplete="new-password" className="h-11 bg-white" data-testid="cp-confirm-input" /></div>
      {error && <div className="rounded-lg border border-rose-200 bg-rose-50 p-3 text-sm text-rose-700" data-testid="cp-error">{error}</div>}
      <Button type="submit" disabled={busy} className="h-11 w-full rounded-full bg-[#0F382C] hover:bg-[#134E3A]" data-testid="cp-submit-btn">
        {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : "Save new password"}
      </Button>
    </form>
  );
}
